import {CustomDateModel} from '../CustomDate/custom-date.model';
import {ChargeV2Model} from '../ChargeModel/charge.model';

export class ReviewModel {
  object?: string;
  id?: string;
  charge_id?: string;
  risk?: string;
  review_desc?: string;
  status?: string;
  charge = new Data<ChargeV2Model>();
  action?: string;
  created_at?: CustomDateModel;
  updated_at?: CustomDateModel;
  amount?:number;
  card_holder_name?:string;
 
  constructor() {
    this.charge.data = new ChargeV2Model();
  }
}

export class Data<T> {
  data: T ;
}
